// ============================================================
// Account module manifest — R3 retrofit (2026-04-24).
//
// Thin platform module: my-profile route + future self-service
// (my-settings, my-notifications). Per the R3 design-debate
// synthesis: 'account' is a platform module, not a domain module.
// Every signed-in user gets it — it's how they reach their own
// data without crossing into HR or Leave.
//
// Sidebar section: 'account' (sits between People and Admin so the
// last items a non-admin user sees are their own).
//
// Depends on hr (fetchMyEmployee) + leave (own entitlements + leave
// requests subscriptions on the profile page) + payroll (calculatePayroll
// for the take-home preview card).
// ============================================================

export default {
  id:          'account',
  name:        'Account',
  version:     '1.0.0',
  description: 'Self-service area for the signed-in user (My Profile).',

  load: () => import('./index.js'),

  routes: [
    {
      id:       'my-profile',
      label:    'My Profile',
      icon:     '👤',
      section:  'account',
      sidebarPosition: 30,
      // 2026-05-04 sidebar-leak fix — gate on `account.read.self`. Every
      // role gets this in every industry pack (it's THE self-service perm).
      // Director's '*' fast-path also covers it. The page reads only the
      // signed-in user's own employee/leave/payroll data.
      visible:  (role, hasPerm) => hasPerm('account.read.self'),
      mount:    'mountMyProfile',
      unmount:  'unmountMyProfile'
    }
  ],

  schemas: [],   // reads only; account doesn't own collections.

  permissions: [
    'account.read.self',
    'account.update.self'    // edit own contact info (future feature)
  ],

  dependencies: ['hr', 'leave', 'payroll'],

  fitsIndustries: ['manufacturing', 'trading', 'services', 'retail'],

  functions: [],

  dashboardWidgets: []
};
